/*
 * @Author: 张斌
 * @Date: 2022-04-11 16:23:33
 * @LastEditors: 张斌
 * @LastEditTime: 2025-12-02 11:17:12
 */
/*
 * @Author: 张斌
 * @Date: 2022-04-11 16:23:33
 * @LastEditors: 张斌
 * @LastEditTime: 2022-04-11 16:27:49
 */
import { commonRequest } from '@/utils/request'
import internal from 'stream'
/** 获取项目参数信息 */
export function getOrgParam(
  orgId: string
) {
  return commonRequest({
    method: 'get',
    url: `/V1/Org/Param/${orgId}`,

  })
}

export function updOrgParam(data: {
  orgEmail: string
  postion: string
  province: string
  city: string
  area: string
  beginTime: string
  endTime: string
  weekdayType:internal
  isSocketPush:internal
  isSocketExpowerPush:internal
  exPowerValue:internal
  orgId:string
  countryCode:string
}) {
  return commonRequest({
    method: 'PUT',
    url: '/V1/Org/Param/',
    data,
  })
}

//查询国内城市代码表
export function getCityInfoList(data: {
  cityId:string
  administrativeOwnership:string
  cityAbbreviation:string
  pinyin:string

}){
  return commonRequest({
    method: 'POST',
    url: '/V1/Admin/DataV/getCityInfoList',
    data,
  })
}


//查询国内外标识
export function getListByType(data: {
  type:string


}){
  return commonRequest({
    method: 'GET',
    url: '/V1/Org/Authc/DataDictionary/ListByType',
    params: data,
  })
}

// 查询舒适温度配置
export function getComfortTem(orgId: string) {
  return commonRequest({
    method: 'GET',
    url: '/V1/Admin/TenInchScreen/getComfortTem',
    params: { orgId },
  })
}

// 保存舒适温度配置
export function saveComfortTem(data: {
  orgId: string
  valueList: number[]
  switchStatus: number
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Admin/TenInchScreen/saveComfortTem',
    data,
  })
}
  